import getPreferences from "./getPreferences";
import type { UserPreferences } from "./types";

/** Pure routing from API preferences shape (shared by async helper + React Query redirect). */
export function postLoginRouteFromUserPreferences(prefs: UserPreferences | undefined, fetchFailed: boolean): string {
  if (fetchFailed || !prefs) return "/preferences";
  return prefs.isDefault === false ? "/weekly-planner" : "/preferences";
}

/**
 * Where to send the user after auth: planner for established users, preferences for onboarding.
 */
export async function resolvePostLoginRoute(): Promise<string> {
  try {
    const prefs = await getPreferences();
    return postLoginRouteFromUserPreferences(prefs, false);
  } catch {
    return "/preferences";
  }
}
